export default __webpack_public_path__ + "static/media/microsoftBI.14259b89.png";